// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__19k6I","question":"styles_question__eS1j7","description":"styles_description__1oMgb"};